import { StatusCode } from "@/constants/statusCodes";

export const isSuccess = (status: number) => status === StatusCode.Success;

export const isSessionExpired = (status: number) =>
    status === StatusCode.SessionExpired ||
    status === StatusCode.AuthenticationFailed;

export const isAuthError = (status: number) =>
    status === StatusCode.AuthorizationFailed;
